import { render, staticRenderFns } from "./ImportPartition.vue?vue&type=template&id=2ca32a81&scoped=true"
import script from "./ImportPartition.vue?vue&type=script&lang=js"
export * from "./ImportPartition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca32a81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca32a81')) {
      api.createRecord('2ca32a81', component.options)
    } else {
      api.reload('2ca32a81', component.options)
    }
    module.hot.accept("./ImportPartition.vue?vue&type=template&id=2ca32a81&scoped=true", function () {
      api.rerender('2ca32a81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/partition/cmp/ImportPartition.vue"
export default component.exports